var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "main" }, [
    _c(
      "div",
      { staticClass: "grid-container" },
      [
        _c("h2", { staticClass: "u-extra-small-margin--bottom" }, [
          _vm._v(_vm._s(_vm.$t("weeks.projectplanningexport.title"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "grid-x grid-margin-x align-middle u-extra-small-margin--bottom",
          },
          [
            _c(
              "div",
              { staticClass: "cell small-12 medium-2" },
              [
                _c("v-datepicker", {
                  staticClass:
                    "form-control form-control--small form-control--date",
                  attrs: {
                    id: "project-planning-export-date",
                    placeholder: _vm.$t("search.from"),
                    format:
                      _vm.$t("search.from") + " " + _vm.$helpers.dateFormat,
                    "disabled-dates": _vm.disabledDates,
                    language: _vm.de,
                    "monday-first": true,
                  },
                  model: {
                    value: _vm.selectedDate,
                    callback: function ($$v) {
                      _vm.selectedDate = $$v
                    },
                    expression: "selectedDate",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "cell small-12 medium-auto" }, [
              _c(
                "button",
                {
                  staticClass: "button secondary",
                  attrs: {
                    disabled:
                      _vm.isLoading || _vm.isSending || !_vm.selectedDate,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.sendToKiPython()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("weeks.projectplanningexport.send_button"))
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button secondary",
                  attrs: {
                    disabled:
                      _vm.isLoading || _vm.isSending || !_vm.selectedDate,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.downloadExport()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("weeks.projectplanningexport.button")))]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cell small-12 medium-auto u-text-right" },
              [
                _c(
                  "button",
                  {
                    staticClass: "button secondary",
                    attrs: { disabled: _vm.isLoading || _vm.isSending },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.downloadHistory()
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("weeks.projectplanningexport.history_button")
                      )
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "text-center u-extra-small-margin--bottom u-extra-small-margin--top",
          },
          [
            _c("v-page-loading", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isLoading || _vm.isSending,
                  expression: "isLoading || isSending",
                },
              ],
            }),
            _vm._v(" "),
            _vm.isSending
              ? _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("weeks.projectplanningexport.send_waiting", {
                        seconds: _vm.sendElapsedSeconds,
                      })
                    )
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.isLoading && _vm.summary
          ? _c("div", { staticClass: "callout success" }, [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t("weeks.projectplanningexport.success", {
                      kolonnen: _vm.summary.kolonnen,
                      projects: _vm.summary.projects,
                    })
                  )
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isLoading && _vm.historySummary
          ? _c("div", { staticClass: "callout success" }, [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t("weeks.projectplanningexport.history_success", {
                      projects: _vm.historySummary.projects,
                    })
                  )
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isLoading && _vm.currentSummary
          ? _c("div", { staticClass: "callout success" }, [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t("weeks.projectplanningexport.current_success", {
                      projects: _vm.currentSummary.projects,
                    })
                  )
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("v-form-message", {
          attrs: {
            type: "error",
            id: "form-error",
            message: _vm.errorMessage,
            autoCloseTimeout: 0,
          },
        }),
        _vm._v(" "),
        _vm.hasAiResult
          ? _c(
              "div",
              { staticClass: "c-ai-result u-extra-large-margin--top" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "grid-x grid-margin-x align-middle u-extra-small-margin--bottom",
                  },
                  [
                    _c("div", { staticClass: "cell small-auto" }, [
                      _c("h3", { staticClass: "u-no-margin--bottom" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("weeks.projectplanningexport.map.title")
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell small-auto" }, [
                      _c("div", { staticClass: "c-ai-result__week-tools" }, [
                        _vm.resultMode === "week"
                          ? _c(
                              "label",
                              { staticClass: "c-ai-result__route-source" },
                              [
                                _c("span", { staticClass: "show-for-sr" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "weeks.projectplanningexport.map.route_source_label"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.mapRouteSource,
                                        expression: "mapRouteSource",
                                      },
                                    ],
                                    staticClass:
                                      "form-control form-control--small form-control--select",
                                    attrs: { disabled: _vm.isSending },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.mapRouteSource = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "ki" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "weeks.projectplanningexport.map.route_ki"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "original" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "weeks.projectplanningexport.map.route_original"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "button-group u-text-right u-no-margin--bottom",
                          },
                          _vm._l(_vm.weekTabs, function (tab) {
                            return _c(
                              "button",
                              {
                                key: tab.date,
                                staticClass: "button",
                                class:
                                  tab.date === _vm.activeWeek
                                    ? "primary"
                                    : "secondary",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.isSending,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.selectWeekTab(tab.date)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(tab.label))]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "grid-x grid-margin-x" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "cell small-12 medium-1 c-ai-result__kolonnen",
                    },
                    [
                      _c("h4", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "weeks.projectplanningexport.map.kolonne_label"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "button-group" },
                        _vm._l(_vm.kolonneOptions, function (kolonne) {
                          return _c(
                            "button",
                            {
                              key: kolonne,
                              staticClass:
                                "button u-extra-small-margin--bottom",
                              class:
                                kolonne === _vm.selectedKolonne
                                  ? "primary"
                                  : "secondary",
                              attrs: {
                                type: "button",
                                disabled: _vm.isSending,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.selectKolonne(kolonne)
                                },
                              },
                            },
                            [_vm._v(_vm._s(kolonne))]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "cell small-12 medium-11" }, [
                    _c(
                      "div",
                      { staticClass: "c-ai-result__map" },
                      [
                        _c("ai-route-map", {
                          attrs: {
                            stops: _vm.mapStops,
                            start: _vm.mapStart,
                            "draw-lines": _vm.showRouteLines,
                            "empty-text": _vm.mapEmptyText,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "grid-x grid-margin-x align-middle u-extra-small-margin--top",
                      },
                      [
                        _c("div", { staticClass: "cell shrink" }, [
                          _c(
                            "label",
                            { staticClass: "c-ai-result__route-toggle" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.showRouteLines,
                                    expression: "showRouteLines",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.showRouteLines)
                                    ? _vm._i(_vm.showRouteLines, null) > -1
                                    : _vm.showRouteLines,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.showRouteLines,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.showRouteLines = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.showRouteLines = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.showRouteLines = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$t(
                                      "weeks.projectplanningexport.map.show_routes"
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "cell auto u-text-right" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "weeks.projectplanningexport.map.legend_title"
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.mapStart
                          ? _c("div", { staticClass: "cell shrink" }, [
                              _c("span", {
                                staticClass:
                                  "c-ai-result__legend-swatch c-ai-result__legend-swatch--start",
                              }),
                              _vm._v("\n                  S\n              "),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.weekdayLegend, function (day) {
                          return _c(
                            "div",
                            { key: day, staticClass: "cell shrink" },
                            [
                              _c("span", {
                                staticClass: "c-ai-result__legend-swatch",
                                style: {
                                  backgroundColor: _vm.weekdayColor(day),
                                },
                              }),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.weekdayShortLabel(day)) +
                                  ".\n              "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "grid-x grid-margin-x align-middle u-extra-large-margin--top u-extra-large-margin--bottom",
                  },
                  [
                    _c("div", { staticClass: "cell small-1" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "cell small-11" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "grid-x grid-margin-x u-extra-large-margin--bottom",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "cell",
                                class:
                                  _vm.resultMode === "week"
                                    ? "small-6"
                                    : "small-12",
                              },
                              [
                                _c(
                                  "h2",
                                  {
                                    staticClass: "u-extra-small-margin--bottom",
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$t(
                                            "weeks.projectplanningexport.map.stops_title"
                                          )
                                        ) +
                                        "\n                     "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "c-ai-result__complete" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "weeks.projectplanningexport.map.total_qm"
                                          )
                                        ) +
                                          " " +
                                          _vm._s(_vm.kiCompleteTotals.qmLabel)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "weeks.projectplanningexport.map.total_km"
                                          )
                                        ) +
                                          " " +
                                          _vm._s(_vm.kiCompleteTotals.kmLabel)
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.resultMode === "week"
                              ? _c("div", { staticClass: "cell small-6" }, [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "u-extra-small-margin--bottom",
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "weeks.projectplanningexport.map.original_title"
                                            )
                                          ) +
                                          "\n                     "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "c-ai-result__complete" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "weeks.projectplanningexport.map.total_qm"
                                            )
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.originalCompleteTotals.qmLabel
                                            )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "weeks.projectplanningexport.map.total_km"
                                            )
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.originalCompleteTotals.kmLabel
                                            )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.kolonneOverviews, function (group) {
                          return _c(
                            "div",
                            {
                              key: group.kolonne,
                              staticClass: "c-ai-result__kolonne-overview",
                            },
                            [
                              _c(
                                "h4",
                                { staticClass: "u-extra-small-margin--bottom" },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t(
                                          "weeks.projectplanningexport.map.kolonne_label"
                                        )
                                      ) +
                                      " " +
                                      _vm._s(group.kolonne) +
                                      "\n                      "
                                  ),
                                  String(group.kolonne) ===
                                  String(_vm.selectedKolonne)
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "c-ai-result__kolonne-overview-note",
                                        },
                                        [
                                          _vm._v(
                                            "\n                          " +
                                              _vm._s(
                                                _vm.$t(
                                                  "weeks.projectplanningexport.map.kolonne_on_map"
                                                )
                                              ) +
                                              "\n                      "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "grid-x grid-margin-x" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cell",
                                      class:
                                        _vm.resultMode === "week"
                                          ? "small-6"
                                          : "small-12",
                                    },
                                    [
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "weeks.projectplanningexport.map.stops_title"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.resultMode === "week"
                                    ? _c(
                                        "div",
                                        { staticClass: "cell small-6" },
                                        [
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "weeks.projectplanningexport.map.original_title"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "grid-x grid-margin-x" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cell",
                                      class:
                                        _vm.resultMode === "week"
                                          ? "small-6"
                                          : "small-12",
                                    },
                                    [
                                      group.stops.length === 0
                                        ? _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "weeks.projectplanningexport.map.no_stops"
                                                )
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      group.kiStart
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "u-extra-small-margin--bottom callout",
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "weeks.projectplanningexport.map.start_note",
                                                      {
                                                        address:
                                                          group.kiStart
                                                            .addressLabel,
                                                        km: group.kiStart
                                                          .kmLabel,
                                                      }
                                                    )
                                                  ) +
                                                  "\n                          "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      group.stops.length > 0
                                        ? _c(
                                            "table",
                                            {
                                              staticClass: "c-ai-result__stops",
                                            },
                                            [
                                              group.stops.length > 0
                                                ? _c("thead", [
                                                    _c("tr", [
                                                      _c("th", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "weeks.projectplanningexport.map.stops_number"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("th", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "weeks.projectplanningexport.map.stops_day"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("th", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "weeks.projectplanningexport.map.stops_address"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("th", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "weeks.projectplanningexport.map.stops_leg_km"
                                                            )
                                                          ) + "*"
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("th", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "weeks.projectplanningexport.map.stops_projects"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.resultMode ===
                                                      "current"
                                                        ? _c("th", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "weeks.projectplanningexport.map.stops_open_qm"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              group.stops.length > 0
                                                ? _c(
                                                    "tbody",
                                                    _vm._l(
                                                      group.stops,
                                                      function (stop) {
                                                        return _c(
                                                          "tr",
                                                          {
                                                            key:
                                                              group.kolonne +
                                                              "-" +
                                                              stop.key,
                                                          },
                                                          [
                                                            _c("td", [
                                                              _c("span", {
                                                                staticClass:
                                                                  "c-ai-result__legend-swatch",
                                                                style: {
                                                                  backgroundColor:
                                                                    _vm.weekdayColor(
                                                                      stop.weekday
                                                                    ),
                                                                },
                                                              }),
                                                              _vm._v(
                                                                "\n                                          " +
                                                                  _vm._s(
                                                                    stop.number
                                                                  ) +
                                                                  "\n                                      "
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  stop.dayLabel
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  stop.addressLabel
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "u-text-right",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    stop.legKmLabel
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              _vm._l(
                                                                stop.projects,
                                                                function (
                                                                  project
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key:
                                                                        stop.key +
                                                                        "-" +
                                                                        project.projectId,
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                          " +
                                                                          _vm._s(
                                                                            project.projectNumber
                                                                          ) +
                                                                          "\n                                          "
                                                                      ),
                                                                      project.dateFixed
                                                                        ? _c(
                                                                            "br"
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      project.dateFixed
                                                                        ? _c(
                                                                            "small",
                                                                            {
                                                                              staticClass:
                                                                                "u-color--alert",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "weeks.project.is_date_fixed"
                                                                                  )
                                                                                )
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.resultMode ===
                                                            "current"
                                                              ? _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      stop.openQmLabel
                                                                    )
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.resultMode === "week"
                                    ? _c(
                                        "div",
                                        { staticClass: "cell small-6" },
                                        [
                                          _vm.weekplanExportLoading
                                            ? _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "weeks.projectplanningexport.map.original_loading"
                                                    )
                                                  )
                                                ),
                                              ])
                                            : _vm.weekplanExportError
                                            ? _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.weekplanExportError
                                                  )
                                                ),
                                              ])
                                            : group.original.length === 0
                                            ? _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "weeks.projectplanningexport.map.original_empty"
                                                    )
                                                  )
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.weekplanExportLoading &&
                                          !_vm.weekplanExportError &&
                                          group.originalStart
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "callout u-extra-small-margin--bottom",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "weeks.projectplanningexport.map.start_note",
                                                          {
                                                            address:
                                                              group
                                                                .originalStart
                                                                .addressLabel,
                                                            km: group
                                                              .originalStart
                                                              .kmLabel,
                                                          }
                                                        )
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.weekplanExportLoading &&
                                          !_vm.weekplanExportError &&
                                          group.original.length > 0
                                            ? _c(
                                                "table",
                                                {
                                                  staticClass:
                                                    "c-ai-result__stops",
                                                },
                                                [
                                                  _c("thead", [
                                                    _c("tr", [
                                                      _c("th", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "weeks.projectplanningexport.map.stops_number"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("th", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "weeks.projectplanningexport.map.stops_day"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("th", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "weeks.projectplanningexport.map.stops_address"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("th", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "weeks.projectplanningexport.map.stops_leg_km"
                                                            )
                                                          ) + "*"
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("th", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "weeks.projectplanningexport.map.stops_projects"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "tbody",
                                                    _vm._l(
                                                      group.original,
                                                      function (row) {
                                                        return _c(
                                                          "tr",
                                                          {
                                                            key:
                                                              group.kolonne +
                                                              "-" +
                                                              row.key,
                                                          },
                                                          [
                                                            _c("td", [
                                                              _c("span", {
                                                                staticClass:
                                                                  "c-ai-result__legend-swatch",
                                                                style: {
                                                                  backgroundColor:
                                                                    _vm.weekdayColor(
                                                                      row.weekday
                                                                    ),
                                                                },
                                                              }),
                                                              _vm._v(
                                                                "\n                                          " +
                                                                  _vm._s(
                                                                    row.number
                                                                  ) +
                                                                  "\n                                      "
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  row.dayLabel
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  row.addressLabel
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "u-text-right",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    row.legKmLabel
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                "\n                                        " +
                                                                  _vm._s(
                                                                    row.projectLabel
                                                                  ) +
                                                                  "\n                                        "
                                                              ),
                                                              row.dateFixed
                                                                ? _c("br")
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              row.dateFixed
                                                                ? _c(
                                                                    "small",
                                                                    {
                                                                      staticClass:
                                                                        "u-color--alert",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "weeks.project.is_date_fixed"
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.unplannedProjects.length > 0
                          ? _c(
                              "div",
                              { staticClass: "u-extra-small-margin--top" },
                              [
                                _c(
                                  "h4",
                                  {
                                    staticClass: "u-extra-small-margin--bottom",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "weeks.projectplanningexport.map.unplanned_title"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass: "u-extra-small-margin--bottom",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "weeks.projectplanningexport.map.unplanned_desc"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.unplannedProjects,
                                  function (project) {
                                    return _c(
                                      "div",
                                      {
                                        key: project.project_id,
                                        staticClass:
                                          "u-extra-small-margin--bottom",
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(project.project_number)
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        project.message
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "u-no-margin--bottom",
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "weeks.projectplanningexport.map.unplanned_reason"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(project.message) +
                                                    "\n                      "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "grid-x grid-margin-x" }, [
                  _c("div", { staticClass: "cell small-1" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "cell small-11 medium-11 u-extra-small-margin--bottom",
                    },
                    [
                      _vm._v(
                        "\n          * " +
                          _vm._s(
                            _vm.$t(
                              "weeks.projectplanningexport.map.km_disclaimer"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }